import { useId } from "react";

import { cn } from "@/lib/utils";

export function ArticlesIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 text-white", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.117 16.656V4.27c0-.764.204-1.342.614-1.735.41-.398.968-.62 1.677-.664.968-.06 1.898-.147 2.789-.257.896-.11 1.757-.238 2.581-.382a49.06 49.06 0 002.39-.49c.831-.2 1.476-.105 1.935.282.46.382.689 1.008.689 1.876v12.13c0 .736-.127 1.295-.382 1.677-.254.387-.692.672-1.311.855a34.3 34.3 0 01-2.906.672 35.72 35.72 0 01-2.772.415c-.908.1-1.826.174-2.756.224-.808.05-1.436-.122-1.884-.515-.443-.387-.664-.954-.664-1.701zM5.37 6.238a34.22 34.22 0 003.254-.357c.99-.16 1.967-.348 2.93-.564.21-.044.346-.116.406-.216a.6.6 0 00.1-.34.45.45 0 00-.158-.349c-.105-.1-.254-.13-.448-.091a51.19 51.19 0 01-2.847.548c-.974.16-2.056.28-3.246.357-.177.01-.307.066-.39.166a.564.564 0 00-.116.357.5.5 0 00.141.356c.094.1.219.144.374.133zm0 2.698a35.973 35.973 0 003.254-.365c.99-.16 1.967-.349 2.93-.565.21-.044.346-.116.406-.215.067-.1.1-.21.1-.333a.484.484 0 00-.158-.365c-.105-.1-.254-.127-.448-.083-.918.21-1.868.396-2.847.556a35.43 35.43 0 01-3.246.349c-.177.011-.307.066-.39.166a.552.552 0 00-.116.349c0 .15.047.274.141.373a.48.48 0 00.374.133zm0 2.69a36 36 0 003.254-.366c.99-.16 1.967-.348 2.93-.564.21-.044.346-.116.406-.216.067-.1.1-.21.1-.332a.475.475 0 00-.158-.357c-.105-.105-.254-.136-.448-.091-.918.204-1.868.387-2.847.548a37.28 37.28 0 01-3.246.357c-.177.016-.307.074-.39.174a.551.551 0 00-.116.348c0 .144.047.266.141.366a.48.48 0 00.374.133zm0 2.68a30.745 30.745 0 001.776-.157c.492-.066.963-.136 1.411-.208a.535.535 0 00.34-.19.551.551 0 00.117-.332.475.475 0 00-.158-.357c-.105-.106-.26-.142-.465-.108-.393.066-.827.13-1.303.19-.47.056-1.046.103-1.727.142-.177.016-.307.074-.39.174a.53.53 0 00-.116.349c0 .144.047.265.141.365a.479.479 0 00.374.133zm3.602 5.33c.708-.11 1.433-.246 2.175-.407a41.056 41.056 0 002.283-.548c.559-.16 1.026-.393 1.403-.697.381-.299.67-.69.863-1.17.194-.482.29-1.077.29-1.785V2.943c0-.138-.005-.274-.016-.407a16.61 16.61 0 00-.042-.44c.548.139.96.42 1.237.847.282.42.423.982.423 1.685V16.92c0 .902-.224 1.58-.672 2.034-.443.454-1.11.68-2 .68H8.973z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BlogIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-5 w-[25px] text-white", className)}
      viewBox="0 0 25 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.427 16.556V11.17a.628.628 0 00-.175-.465.628.628 0 00-.464-.174h-3.072a.657.657 0 00-.473.174.628.628 0 00-.174.465v5.387h4.358zm-9.62-.282V9.949l6.939-5.82c.337-.287.678-.287 1.02 0l6.94 5.82v6.325c0 .598-.177 1.065-.531 1.403-.354.337-.836.506-1.445.506H6.782c-.615 0-1.099-.169-1.453-.506-.349-.338-.523-.805-.523-1.403zm-2.69-7.462c0-.255.108-.474.323-.656L11.09.893c.36-.3.75-.449 1.17-.449.42 0 .808.15 1.162.449l8.642 7.263a.841.841 0 01.323.68.696.696 0 01-.249.565.883.883 0 01-.598.207.777.777 0 01-.365-.09 2.153 2.153 0 01-.323-.208l-8.235-6.915a.546.546 0 00-.357-.15c-.121 0-.24.05-.357.15L3.661 9.31a2.566 2.566 0 01-.332.207.729.729 0 01-.357.091c-.266 0-.476-.077-.631-.232a.802.802 0 01-.224-.564zm15.265-4.026V2.752c0-.183.055-.33.166-.44a.607.607 0 01.448-.174h1.12a.59.59 0 01.449.174c.11.11.166.257.166.44v4.01l-2.35-1.976z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ClaimBusinessIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M4.944 2.058a2.392 2.392 0 00-.437.19c-.242.13-.457.371-1.655 1.843-.8.983-1.435 1.811-1.515 1.978-.131.274-.138.33-.154 1.287-.01.602.006 1.11.04 1.275.133.63.6 1.22 1.197 1.513.313.153.383.167.836.165.621-.003.972-.13 1.375-.498.61-.558.706-.896.706-2.478v-1.16l.735-1.834.832-2.083L7 2.01l-.949.006c-.522.003-1.02.022-1.108.043zm3.677.068l-.836 2.092-.79 1.975.017 1.278.017 1.278.165.348c.229.484.524.785.998 1.02.371.183.42.194.893.194.472 0 .521-.011.893-.195.474-.234.769-.535.998-1.019l.165-.348.014-3.37.015-3.37H9.918c-1.25 0-1.252 0-1.297.117zm4.222 3.252l.015 3.371.165.348c.23.484.524.785.998 1.02.371.183.42.194.893.194.472 0 .521-.011.893-.195.474-.234.769-.535.998-1.019l.165-.348.017-1.278.017-1.278-.832-2.079-.83-2.079-1.257-.014-1.257-.014.015 3.371zm4.25-3.126l.834 2.087.734 1.835v1.16c0 1.581.097 1.92.707 2.477.403.368.754.495 1.376.498.456.002.524-.012.837-.166.597-.294 1.062-.882 1.194-1.512.035-.165.051-.673.041-1.275-.016-.958-.023-1.013-.155-1.287-.08-.167-.714-.995-1.516-1.98-1.292-1.588-1.4-1.706-1.71-1.874l-.331-.18-1.055-.017L16.994 2l.1.252zM5.853 10.91c-.66.685-1.647 1.092-2.648 1.092h-.367l.013 4.733c.014 4.687.015 4.733.121 4.876.06.079.172.192.251.25.136.102.224.11 1.544.124l4.74.015H12s2.508-.003 2.5 0l.008-.003 1.308-.014c4.686-.014 4.817-.015 4.96-.121.078-.06.191-.172.25-.251.107-.143.108-.189.121-4.863l.014-4.72-.456-.003a4.15 4.15 0 01-.742-.072c-.693-.165-1.419-.582-1.865-1.07l-.26-.283-.334.327a3.672 3.672 0 01-5.175.005l-.33-.323-.329.323a3.672 3.672 0 01-5.177-.006 6.17 6.17 0 00-.342-.323l-.297.307z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10.343 18.337l4.991-4.911a.794.794 0 011.11 0 .763.763 0 010 1.091l-5.547 5.457a.793.793 0 01-1.109 0L7.57 17.791a.763.763 0 010-1.091.794.794 0 011.109 0l1.664 1.637z"
        fill="#354266"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function DashboardIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      viewBox="0 0 36 38"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${id})`}>
        <path
          d="M14.638 19.608c.133.62-.244 1.23-.834 1.46-2.595 1.009-4.607 2.927-5.483 5.28C7.798 27.75 9.054 29 10.55 29h14.89c1.497 0 2.752-1.25 2.23-2.652-.876-2.353-2.888-4.27-5.483-5.28-.59-.23-.967-.84-.834-1.46a1.35 1.35 0 01.335-.624c.97-1.057 1.571-2.528 1.571-4.154 0-3.22-2.357-5.83-5.264-5.83-2.906 0-5.263 2.61-5.263 5.83 0 1.626.601 3.097 1.571 4.154.162.177.285.39.335.624z"
          fill="currentColor"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="36.309"
          id={id}
          width="35.9"
          x="0.046"
          y="0.845"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.077" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_14941_224081"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_14941_224081"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function ExploreBusinessIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M2 4a2 2 0 012-2h16a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4zm14.456 0H7.692a.125.125 0 00-.136.114.126.126 0 00.111.139l6.8 1.46a.25.25 0 01.196.252v12.078a.251.251 0 01-.197.252l-6.799 1.452a.126.126 0 00-.11.139c.006.07.067.12.135.113h8.764a.25.25 0 00.246-.252V4.253A.25.25 0 0016.455 4zm-3.251 9.067c.148 0 .269-.24.269-.534 0-.294-.12-.533-.27-.533-.148 0-.268.239-.268.533 0 .295.12.534.269.534z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function ExternalIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[15px] text-pale-lavender", className)}
      fill="none"
      viewBox="0 0 15 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.125 8.625v.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311c-.642.327-1.482.327-3.162.327h-1.65c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.31c-.327-.642-.327-1.482-.327-3.163v-1.65c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.31c.642-.328 1.482-.328 3.162-.328h.2M7.2 8.3l5.925-5.925m0 0H9.678m3.447 0v3.447"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
    </svg>
  );
}

export function LogoIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-9 w-29 text-white", className)}
      fill="none"
      viewBox="0 0 116 36"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.025.001H.306a.28.28 0 00-.305.256.283.283 0 00.25.312l15.298 3.285a.564.564 0 01.444.567v27.175a.564.564 0 01-.444.567L.251 35.431a.283.283 0 00-.25.312.28.28 0 00.305.256h19.719a.56.56 0 00.554-.568V.57a.56.56 0 00-.554-.57z"
        fill={`url(#${id})`}
      />
      <ellipse cx="12.711" cy="19.2" fill="currentColor" rx="0.605" ry="1.2" />
      <g fill="currentColor">
        <path d="M48.05 15.001L43.164 23.5h-.397l-4.887-8.69h-.08V27.6h-3.903V8.4h4.392l4.666 8.996h.055l3.414-6.662a4.271 4.271 0 013.8-2.334h1.832v19.2H48.16V15.001h-.11z" />
        <path
          clipRule="evenodd"
          d="M61.747 13.2c-4.516 0-7.267 2.746-7.267 7.2 0 4.454 2.751 7.2 7.267 7.2 4.515 0 7.26-2.746 7.26-7.2 0-4.454-2.745-7.2-7.26-7.2zm2.97 6.107v2.186c0 2.03-1.118 3.176-2.97 3.176-1.853 0-2.977-1.147-2.977-3.177v-2.185c0-2.023 1.13-3.17 2.976-3.17 1.847 0 2.97 1.146 2.97 3.17z"
          fillRule="evenodd"
        />
        <path d="M73.464 24.365v-7.96h-3.25V13.2h7.288v3.74h.19c.61-1.87 1.936-3.74 4.5-3.74h1.339v3.784h-3c-1.801 0-3.054.81-3.054 2.425v4.987h4.636V27.6H70.216v-3.204l3.25-.031zm15.086-.866v-6.355h-3.808v-3.738h2.473c1.219 0 1.663-.412 1.663-1.675V8.4h3.698v5.006h5.482v3.165h-5.482v7.864h5.482V27.6h-5.196c-2.924 0-4.313-1.706-4.313-4.101zM115.002 13.2l-6.57 15.5-.238.565c-.841 2.012-2.157 3.135-4.621 3.135h-2.853v-3.075h2.414c.677 0 1.097-.216 1.304-.642.046-.086.079-.177.1-.27l.552-1.448-.47-1.111-5.354-12.648h4.451l2.1 5.82 1.317 4.023h.219l1.254-4.024 2.157-5.819 4.238-.006z" />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="20.589"
          x2="20.589"
          y1="35.987"
          y2="0.001"
        >
          <stop stopColor="#90278e" />
          <stop offset="1" stopColor="#ec297b" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function MenuIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[23px] text-white", className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.444 9.555l5 5 5-5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function NewsIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-5 w-6 text-white", className)}
      viewBox="0 0 24 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.117 9.251c0-.387.077-.716.232-.987.16-.277.376-.485.648-.623.27-.138.58-.207.93-.207h.34v9.155c0 .227-.05.418-.15.573a.92.92 0 01-.398.357 1.2 1.2 0 01-.523.133 1.19 1.19 0 01-.54-.125.988.988 0 01-.39-.365c-.1-.155-.15-.346-.15-.573V9.251zm2.938 9.746c.31-.166.526-.38.648-.64.121-.254.182-.595.182-1.02V3.722c0-.89.23-1.563.69-2.017.459-.454 1.136-.68 2.033-.68h9.587c.902 0 1.583.226 2.042.68.46.454.69 1.126.69 2.017V16.3c0 .885-.23 1.555-.69 2.009-.459.459-1.14.689-2.042.689H5.055zm4.35-12.8h8.01a.517.517 0 00.39-.166.543.543 0 00.166-.399.507.507 0 00-.166-.382.53.53 0 00-.39-.157h-8.01a.568.568 0 00-.407.157.52.52 0 00-.158.382.553.553 0 00.564.564zm0 2.864h8.01c.155 0 .285-.05.39-.15a.526.526 0 00.166-.398.516.516 0 00-.166-.39.517.517 0 00-.39-.166h-8.01a.553.553 0 00-.565.556c0 .16.053.293.158.398.11.1.246.15.407.15zm5.047 2.88h2.963a.53.53 0 00.39-.158.52.52 0 00.158-.382.55.55 0 00-.158-.406.53.53 0 00-.39-.158h-2.963a.54.54 0 00-.556.564.54.54 0 00.556.54zm0 2.897h2.963a.53.53 0 00.39-.158.52.52 0 00.158-.382.54.54 0 00-.158-.398.517.517 0 00-.39-.166h-2.963a.526.526 0 00-.399.166.54.54 0 00-.158.398.54.54 0 00.556.54zm-4.624.033h1.992c.31 0 .554-.088.73-.266.178-.177.266-.42.266-.73v-2.042c0-.31-.088-.553-.265-.73-.177-.178-.42-.266-.73-.266H9.827c-.315 0-.562.088-.739.265-.171.178-.257.421-.257.731v2.042c0 .31.086.553.257.73.177.178.424.266.74.266z"
        fill="currentColor"
      />
    </svg>
  );
}

export function OperatorsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-5 w-[23px] text-white", className)}
      viewBox="0 0 23 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.213 19.295c-.631 0-1.123-.171-1.478-.514-.354-.343-.53-.822-.53-1.436v-6.583c.265.127.541.227.83.299.292.066.597.1.912.1a3.579 3.579 0 002.175-.723 3.579 3.579 0 002.175.722c.41 0 .797-.063 1.162-.19.37-.128.706-.302 1.004-.523.305.221.64.395 1.005.523.365.127.755.19 1.17.19.41 0 .797-.063 1.162-.19a3.82 3.82 0 001.013-.523 3.583 3.583 0 002.166.713 3.726 3.726 0 001.735-.432v6.617c0 .614-.174 1.093-.523 1.436-.348.343-.838.514-1.469.514H5.212zm.98-1.494h4.556v-4.275a.628.628 0 00-.174-.464.628.628 0 00-.465-.175H6.84c-.2 0-.357.058-.473.175a.628.628 0 00-.175.464v4.275zM13.222 16h3.362c.188 0 .34-.058.456-.174a.613.613 0 00.183-.465V13.07a.6.6 0 00-.183-.457.602.602 0 00-.456-.182h-3.362a.64.64 0 00-.473.182.617.617 0 00-.174.457v2.29c0 .195.058.35.174.466.122.116.28.174.473.174zM4.208 2.702v-.166c0-.559.167-1.001.499-1.328C5.044.876 5.5.71 6.077.71h10.707c.57 0 1.021.166 1.353.498.332.327.498.77.498 1.328v.166H4.208zM2.266 6.811c.017-.033.033-.064.05-.091l.05-.1L4 3.607h14.85l1.635 3.013.05.1c.017.027.033.058.05.091H2.266zm2.648 3.445c-.515 0-.985-.105-1.411-.316a2.862 2.862 0 01-1.013-.838 1.892 1.892 0 01-.373-1.12v-.274h18.627v.132c0 .399-.125.783-.374 1.154a2.925 2.925 0 01-1.013.905 2.86 2.86 0 01-1.419.357c-.448 0-.86-.094-1.237-.282a2.72 2.72 0 01-.921-.772 2.726 2.726 0 01-2.183 1.054c-.443 0-.852-.094-1.229-.282a2.779 2.779 0 01-.938-.772 2.779 2.779 0 01-.938.772 2.726 2.726 0 01-1.237.282c-.448 0-.86-.094-1.236-.282a2.803 2.803 0 01-.93-.772 2.78 2.78 0 01-.938.772 2.726 2.726 0 01-1.237.282z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PhoneIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[22px] w-[21px] text-white", className)}
      fill="none"
      viewBox="0 0 21 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.07 15.806C1.476 11.213.902 7.244.915 5.485c.005-.637.322-1.206.772-1.657l1.936-1.935a1.263 1.263 0 011.786 0l3.099 3.1a1.263 1.263 0 010 1.785L6.9 8.387a.81.81 0 00-.161.934 13.092 13.092 0 005.816 5.817.81.81 0 00.934-.162l1.608-1.608a1.263 1.263 0 011.787 0l3.078 3.079a1.263 1.263 0 010 1.786l-1.941 1.941c-.447.447-1.01.762-1.642.77-1.75.02-5.71-.539-10.31-5.138z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="1.3"
      />
    </svg>
  );
}

export function SearchIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4.5 text-white", className)}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 17l-3.604-3.604"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
      <circle
        cx="8.276"
        cy="8.276"
        fill="none"
        r="7.276"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  );
}
